"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arkReact = require("@dateam/ark-react");
var _DropdownMenuItem = _interopRequireDefault(require("./DropdownMenuItem"));
var _popover = _interopRequireDefault(require("../popover"));
var _ark = require("@dateam/ark");
const getAnchorElement = anchorEl => {
  if (!(0, _ark.isDefined)(anchorEl)) return document.body;
  if ((0, _ark.isString)(anchorEl)) {
    const element = document.getElementById(anchorEl);
    return element ?? document.body;
  }
  if (! /*#__PURE__*/_react.default.isValidElement(anchorEl)) {
    const ref = anchorEl;
    if ((0, _ark.isObjectLike)(ref) && (0, _ark.hasProperty)(ref, 'current')) return ref.current ?? document.body;
    return document.body;
  }
  return anchorEl;
};
const DropdownMenu = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    id,
    className,
    children,
    open,
    anchorEl,
    onClose
  } = _ref;
  if (open !== true) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  const elementRect = _react.default.useMemo(() => {
    const element = getAnchorElement(anchorEl);
    if (!(0, _ark.isDefined)(element)) return new DOMRect(0, 0, 100, 0);
    return element.getBoundingClientRect();
  }, [anchorEl]);
  return /*#__PURE__*/_react.default.createElement(_popover.default, {
    ref: ref,
    anchorEl: anchorEl,
    overflow: false,
    className: (0, _arkReact.concatClassName)('dropdownMenu', open ? 'dropdownMenu-open' : null, className),
    style: {
      minWidth: `${elementRect.width}px`
    },
    onClickOutside: onClose
  }, children)
  // <div
  //     ref={elementRef}
  //     style={positionStyle}
  //     className={concatClassName(
  //         'dropdownMenu',
  //         open ? 'dropdownMenu-open' : null,
  //         className
  //     )}
  // >
  //     {children}
  // </div>
  ;
});
process.env.NODE_ENV !== "production" ? DropdownMenu.propTypes = {
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  open: _propTypes.default.bool,
  onClose: _propTypes.default.func
} : void 0;
DropdownMenu.defaultProps = {
  id: undefined,
  className: undefined,
  children: undefined,
  open: false,
  onClose: undefined
};
var _default = exports.default = Object.assign(DropdownMenu, {
  Item: _DropdownMenuItem.default
});